<template>
  <div class="container">
    <span class="form p-fluid">
      <AutoComplete
        class="p-mx-3 autocomplete"
        v-model="queries"
        :multiple="true"
        :suggestions="filteredTags"
        @complete="search($event)"
        @item-select="req"
        :delay="100"
        placeholder="例)  ヨルシカ  紫咲シオン"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AutoComplete from "primevue/autocomplete";
import firebase from "../firebase/firebase";
import { useStore } from "vuex";

export default defineComponent({
  name: "InputTags",
  components: { AutoComplete },
  data() {
    return {
      queries: [],
      filteredTags: [""], // 仮
      tags: [""], // 仮
    };
  },
  setup() {
    const store = useStore();

    return {
      store: store,
    };
  },
  mounted() {
    this.queries = this.store.state.query.query;
    firebase
      .firestore()
      .collection("misc")
      .doc("tags")
      .get()
      .then((d) => {
        const tmp: any = d.data();
        tmp.tags.forEach((element: string) => {
          this.filteredTags.push(element);
          this.tags.push(element);
        });
      });
  },
  methods: {
    search({ query }: any) {
      if (!query.trim()) {
        this.filteredTags = [...this.tags];
        return;
      }
      // eslint-disable-next-line
      this.filteredTags = this.tags.filter((f: any) => f.includes(query));
    },
    req(e: Event) {
      console.log(this.queries);
      this.store.commit("set", this.queries);
    },
  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
